<template>
  <div>
    <full-width data-e2e-attr="login-page">
      <back-button destination="Home" />
      <centralized>
        <h2
            class="items-center justify-center mt-4 text-2xl font-bold leading-9 tracking-tight text-center tmsk-blue-text"
        >
          Pre-order Additional Masks
        </h2>
        <div class="flex items-center justify-center h-full mt-8">
          <img src="@/assets/img/mobile-login-logo.png" class="mr-5 h-14" />
          <h2
              class="items-center justify-center text-2xl font-bold leading-9 tracking-tight text-center tmsk-blue-text"
          >
            Mobile Login
            <tooltip>
              <p data-e2e-attr='mobile-login-tooltip'>Pre-order period: {{ preOrderPeriod }}</p>
              <p data-e2e-attr='mobile-login-tooltip'>Collection period: {{ collectionPeriod }}</p>
              <p class="mt-4" data-e2e-attr='mobile-login-tooltip'>
                For details on free mask collection eligibility, pre-order quota and locations,
                <a  data-e2e-attr='mobile-login-tooltip'
                    class="font-bold underline"
                    :href="cheatSheetLink"
                    target="_blank"
                >click here</a
                >.
              </p>
            </tooltip>
          </h2>
        </div>
        <div class="grid max-w-md gap-3 mx-auto mt-2">
          <div>
            <p
                class="max-w-2xl mx-auto text-base leading-7 text-center tmsk-blue-text"
            >
              Enter your
              <span class="font-bold">Singapore registered mobile number</span>
              <br v-if="activeBreakpoint !== 'sm'" />
              to receive a
              <span class="font-bold">One Time Password (OTP)</span>
            </p>
          </div>
          <mobile-number-input
              @handleValid="boolean => (valid = boolean)"
              @handleInput="string => (input = string)"
              class="mt-3"
          />
          <div class="mt-3 flex items-start">
            <input
                v-model="consent"
                data-e2e-attr="tnc-consent-checkbox"
                type="checkbox"
                style="box-shadow: none !important;"
                class="w-4 h-4 mt-1 transition duration-150 ease-in-out tmsk-blue-text form-checkbox"
                @keyup.enter="handleSubmit"
            />
            <p class="ml-4 text-sm tmsk-blue-text">
              By proceeding, you are agreeing to our
              <a
                  class="underline cursor-pointer"
                  @click="
                openUrl('https://stayprepared.sg/staymasked/terms-of-use/')
              "
              >Terms of Use</a
              >
              and
              <a
                  class="underline cursor-pointer"
                  @click="
                openUrl('https://stayprepared.sg/staymasked/privacy-statement/')
              "
              >Privacy Statement</a
              >
            </p>
          </div>
          <button
              data-e2e-attr="submit-otp-btn"
              :style="!consent && 'box-shadow: none !important;'"
              :class="!consent && 'opacity-50 cursor-not-allowed'"
              class="mt-3 w-full p-2 text-sm text-white border border-transparent rounded-full shadow-sm tmsk-blue-bg focus:border-teal-700 focus:shadow-outline-teal focus:outline-none"
              @click="handleSubmit"
          >
            {{ $t("verification.mobileNumber.input.submit") }}
          </button>
        </div>
      </centralized>
    </full-width>
    <verify-otp-modal
      v-if="requestOtpStates.hasRequestedOTP"
      :recipient="requestOtpStates.recipient"
      :testOTP="requestOtpStates.otp"
      :hashPass="requestOtpStates.hashPass"
      :fromName="requestOtpStates.fromName"
      @reset="handleReset"
    />
  </div>
</template>

<script>
import VerifyOtpModal from '../verifyOtpModal/VerifyOtpModal.vue'
import { mapState, mapActions, mapGetters } from 'vuex'
import BackButton from '../../../components/BackButton'
import Centralized from '../../../components/Layout/Centralized'
import FullWidth from '../../../components/Layout/FullWidth'
import Tooltip from '../../../components/Tooltip'
import MobileNumberInput from '../../../components/MobileNumberInput'
import { PREORDER_PERIOD, COLLECTION_PERIOD, CHEATSHEET_URL, SMS_PROVIDER } from '../../../Constants'

export default {
  name: 'Login',
  metaInfo () {
    return {
      title: 'Mobile Login',
      // meta: [
      //   { property: 'og:title', content: 'Mobile Login' },
      //   { property: 'og:url', content: window.location.href },
      //   { property: 'og:site_name', content: 'Mobile Login' },
      //   { property: 'og:image', content: 'https://s3-ap-southeast-1.amazonaws.com/mask.stayprepared.sg/assets/staymasked-og-04.jpg' }
      // ],
      link: [{ rel: 'canonical', href: window.location.href }]
    }
  },
  components: {
    VerifyOtpModal,
    BackButton,
    Centralized,
    FullWidth,
    Tooltip,
    MobileNumberInput
  },
  data () {
    return {
      valid: false,
      input: '',
      consent: false
    }
  },
  computed: {
    ...mapState(['isLoggedIn']),
    ...mapGetters(['requestOtpStates', 'activeBreakpoint'])
  },
  created () {
    this.preOrderPeriod = PREORDER_PERIOD
    this.collectionPeriod = COLLECTION_PERIOD
    this.cheatSheetLink = CHEATSHEET_URL

    if (this.isLoggedIn) {
      this.$router.push('/')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (['Purchase'].includes(from.name)) {
        vm.updateRouteName(from.name)
      }
    })
  },
  methods: {
    ...mapActions(['updateRouteName', 'getUserOtp', 'handleReset']),
    async generateOTP () {
      this.setIsLoading(true)
      await this.getUserOtp({
        phoneNumber: this.input,
        provider: SMS_PROVIDER
      })
      this.setIsLoading(false)
    },
    handleSubmit () {
      if (this.consent && this.valid) {
        this.generateOTP()
      }
    },
    openUrl (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped></style>
